import React from "react";
import { useNavigate } from "react-router-dom";
import UseContext from "hooks/useContext";
import { ChevronRight, Close } from "assets/icons";

const TEMPLATE_PAGES = [
    "Secteur d'activité",
    "Pré-requis",
    "Lieu & Rémunération",
    "Informations supp.",
    "Confirmation",
];

const TemplateSubNav = () => {
    const navigate = useNavigate();
    const { templatePage, resetTemplateData } = UseContext();

    const handleClose = (e) => {
        e.preventDefault();
        const confirmed = window.confirm(
            "Êtes-vous sûr de vouloir quitter la page ? Vos modifications ne seront pas enregistrées."
        );
        if (confirmed) {
            resetTemplateData();
            navigate("/jobPostTemplates");
        }
    };

    if (templatePage <= 0 || templatePage > TEMPLATE_PAGES.length) {
        return null;
    }

    return (
        <div
            className={
                "flex justify-between px-5 gap-3 border-b select-none min-h-[66px] max-h-[66px]"
            }
        >
            <div
                className={
                    "my-auto flex gap-1 whitespace-nowrap overflow-x-auto no-scrollbar ft-sm pr-5 py-4"
                }
            >
                {TEMPLATE_PAGES.map((label, index) => (
                    <div key={index} className={"flex items-center gap-1"}>
                        <div
                            className={`my-auto py-2 px-3 border rounded-lg ${
                                templatePage - 1 === index
                                    ? "bg-yellow-50 border-yellow-300 text-yellow-500"
                                    : templatePage - 1 > index
                                    ? "bg-yellow-50 text-yellow-500 border-white"
                                    : "bg-gray-50 border-white"
                            }`}
                        >
                            {label}
                        </div>
                        {index < TEMPLATE_PAGES.length - 1 && (
                            <div className={"my-auto"}>
                                <ChevronRight wh={16} color={"#6B7280"} />
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className={"my-auto flex gap-2 py-4 border-l pl-3"}>
                <button
                    type="button"
                    className={
                        "cursor-pointer border rounded p-1 hover:bg-gray-50"
                    }
                    onClick={handleClose}
                    aria-label="Quitter la création de fiche de poste"
                >
                    <Close wh={20} color={"#374151"} />
                </button>
            </div>
        </div>
    );
};

export default TemplateSubNav;
